import { TFetchSessionsResponse } from "./session-types"

type TSession = TFetchSessionsResponse["sessions"][number]

const STORAGE_KEY = "seal.selected_session"

// A session is identified by user + which cookie (regular vs admin), since the
// same user_id can appear once per cookie.
export function isSameSession(a: TSession, b: TSession) {
  return a.user_id === b.user_id && a.is_admin === b.is_admin
}

export function storeSelectedSession(session: TSession) {
  localStorage.setItem(STORAGE_KEY, sessionKey(session))
}

export function clearStoredSelectedSession() {
  localStorage.removeItem(STORAGE_KEY)
}

// The loaded session matching the stored selection, or undefined. Read-only.
export function findStoredSelectedSession(sessions: TSession[]) {
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === null) {
    return undefined
  }
  return sessions.find((session) => sessionKey(session) === stored)
}

function sessionKey(session: TSession) {
  return `${session.user_id}:${session.is_admin}`
}
